import { render, staticRenderFns } from "./CertificatedTest.vue?vue&type=template&id=4681addf&"
import script from "./CertificatedTest.vue?vue&type=script&lang=js&"
export * from "./CertificatedTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports